import { useState, useCallback } from 'react';
import { getQrConfigurations } from 'api/qr';
import { QrConfiguration, QrConfigListResponse } from '../types';

export const useQrConfigurations = () => {
    const [items, setItems] = useState<QrConfiguration[]>([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);

    const fetchPage = useCallback(async (p: number, s: string) => {
        setLoading(true);
        try {
            const resp = await getQrConfigurations(p, s);
            const data: QrConfigListResponse = resp.data;
            setItems(data.items);
            setTotal(data.total);
            setPage(p);
            setSearch(s);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, []);

    const refresh = useCallback(() => {
        fetchPage(page, search);
    }, [fetchPage, page, search]);

    return { items, total, page, search, loading, fetchPage, refresh };
};
